import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// sweetalert2 components
import Swal from "sweetalert2";

function CheckSignOut({ reference, title, message, showModal, signalCloseModal }) {
  const [open, setOpen] = useState(false);

  const handleCancelCreation = () => {
    setOpen(false);
    signalCloseModal(false);
  };

  const handleCreation = () => {
    setOpen(false);
    signalCloseModal(true);
    routeChange();
  };

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `${reference}`;
    navigate(path);
  };

  function createSweetAlert() {
    Swal.fire({
      title: `${title}`,
      html: `${message}`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Signout",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleCreation();
      } else {
        handleCancelCreation();
      }
    });
  }

  useEffect(() => {
    setOpen(showModal);
    if (showModal) createSweetAlert();
  }, [showModal]);

  return <div></div>;
}

// Setting default values for the props of CreateTemplate
CheckSignOut.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreateTemplate
CheckSignOut.propTypes = {
  reference: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
};

export default CheckSignOut;
